var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.81,29 12.63,25.06 16.24,20.02 12.63,20.02 12.63,18.23 25.54,10.78 38.45,18.23 38.45,22.96 41.19,19.14  43.95,23.01 43.95,15.06 25.54,4.43 7.13,15.06 7.13,20.02 3.39,20.02 7.13,25.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.95,25.92 41.19,22.06 38.45,25.88 34.76,31.04 38.45,31.04 38.45,33.14 25.54,40.59 12.63,33.14 12.63,28.02  9.81,31.96 7.13,28.22 7.13,36.32 25.54,46.94 43.95,36.32 43.95,31.04 47.61,31.04  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.96,25.5c0,4.74,3.84,8.58,8.58,8.58c4.74,0,8.58-3.84,8.58-8.58c0-4.74-3.84-8.58-8.58-8.58 C20.8,16.92,16.96,20.76,16.96,25.5z M29.96,24.5v2h-3.42v3.42h-2V26.5h-3.42v-2h3.42v-3.42h2v3.42H29.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/recovery.4f9cdadb0aa9dbf0ceb7f55d98048155.svg";
export { ForwardRef as ReactComponent };